import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webhook-item',
  templateUrl: './webhook-item.component.html',
  styleUrls: ['./webhook-item.component.css']
})
export class WebhookItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
